import Swiper from "swiper";

export const SwiperJoaoPessoa = () => {
	// console.log("SwiperHeroHome");
	console.log('teste')
	const slide = new Swiper(".swiper-joao-pessoa", {
		loop: true,
		slidesPerView: 1,
		spaceBetween: 0,
		autoplay: 3000,
		breakpoints: {
			0: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 1,
			},
			1024: {
				slidesPerView: 1,
			},
		},
	});

	const prevBtn = document.getElementById("prev-swiper-joao-pessoa");
	const nextBtn = document.getElementById("next-swiper-joao-pessoa");

	// Add disabled ao btn quando preciso
	const updateNavButtons = () => {
		if (slide.isBeginning) {
			prevBtn.disabled = true;
		} else {
			prevBtn.disabled = false;
		}

		if (slide.isEnd) {
			nextBtn.disabled = true;
		} else {
			nextBtn.disabled = false;
		}
	};

	prevBtn.addEventListener("click", () => {
		slide.slidePrev();
		updateNavButtons();
	});

	nextBtn.addEventListener("click", () => {
		slide.slideNext();
		updateNavButtons();
	});

	updateNavButtons();

};
